module.exports = __webpack_public_path__ + "c225795eed582fafa94b7d64aa6c47d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-4.jpg
// module id = 1177
// module chunks = 0